import { borderColor, brandPrimary, error, header, label } from '@Styles/colors';
import { CssSelectors } from '@Styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		maxWidth: 600,
		alignItems: 'center',
		paddingTop: 30,
		paddingLeft: 200,
		paddingRight: 200,
	},
	tabView: {
		width: '100%',
	},
	tabViewTabs: {
		display: 'flex',
		borderBottom: `1px solid ${borderColor}`,
	},
	tabViewItem: {
		color: header,
		display: 'inline-flex',
		flexBasis: 'auto',
		fontSize: 14,
		height: 44,
		padding: '0 36px',
		textAlign: 'center',
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
		gap: 8,
	},
	tabItemSelected: {
		borderBottom: `1px solid ${brandPrimary}`,
	},
	section: {
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		alignItems: 'center',
		padding: 16,
	},
	inputWrapper: {
		width: 300,
	},
	logo: {
		...CssSelectors.allChildren({
			display: 'block',
			width: 350,
		}),
	},
	signInFormField: {
		display: 'flex',
		margin: 0,
		width: 300,
	},
	textInput: {
		width: '100%',
	},
	signInFormFieldLabel: {
		color: label,
		display: 'block',
		fontSize: 14,
		lineHeight: '22px',
	},
	signInFormFieldError: {
		color: error,
		display: 'block',
		fontSize: 13,
		lineHeight: '18px',
		marginTop: 4,
	},
	signInContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		alignItems: 'center',
	},
	signInForm: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
});
